const removeSpaces = (text) => {
    return text.replace(/\s*/g, '')
}

export { removeSpaces }
